import {useVaultDispatch} from "../../core/top/VaultContext";

const {onClickLoginAsStudent} = require("../../parent/util/ParentUtil");

export interface Student {
	id: string;
	displayName: string;
	username?: string;
	avatarData?: any;
	hasRegistered?: boolean;
	isActive?: boolean;
}

export const useStudentLogin = (
	student: Student,
	method: string = "generic"
) => {
	const dispatch = useVaultDispatch();

	const handleClick = () => {
		if (student.hasRegistered) {
			onClickLoginAsStudent(dispatch, student, method);
		} else {
			// Redirect to registration page for unregistered students
			window.location.href = "/parent/students/setup";
		}
	};

	return {
		handleClick,
		isRegistered: student.hasRegistered || false,
		displayName: student.displayName,
		username: student.username,
		avatar: student.avatarData,
		studentId: student.id,
	};
};
